import React from 'react';
import { PrimaryButton } from '../../components';
import css from './CartPage.module.css';

/** A shop's "Check out": its label names the shop for screen readers. */
const CartButton = props => {
  const { onSubmit, disabled = false, label, ariaLabel, ariaDescribedBy } = props;
  return (
    <PrimaryButton
      className={css.checkoutButton}
      onClick={onSubmit}
      disabled={disabled}
      aria-label={ariaLabel || undefined}
      aria-describedby={ariaDescribedBy || undefined}
    >
      {label}
    </PrimaryButton>
  );
};

export default CartButton;
